import React from 'react'

export default function Footer() {
    return (
        <div>
            <p style={{ textAlign: 'center' }} >Copy Right @2020</p>
        </div >
    )
}
